import React, { useState } from "react";
import remediesData from "../data/private/remedies.json";
import InfoBanner from "../components/InfoBanner";
import { logActivity } from "../utils/activity";

export default function DashboardRemedies() {
  const [activeFilter, setActiveFilter] = useState(remediesData.filters[0]);
  const [dismissed, setDismissed] = useState(
    Boolean(localStorage.getItem("myv_guidance_remedies"))
  );
  const filtered = remediesData.items.filter(
    (item) => item.type === activeFilter
  );

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold text-slate-900">
          {remediesData.title}
        </h1>
        <p className="mt-2 text-sm text-slate-600">{remediesData.subtitle}</p>
      </div>

      <div className="flex flex-wrap gap-2">
        {remediesData.filters.map((filter) => (
          <button
            key={filter}
            className={`btn ${
              activeFilter === filter ? "btn-primary" : "btn-secondary"
            }`}
            onClick={() => setActiveFilter(filter)}
          >
            {filter}
          </button>
        ))}
      </div>

      {!dismissed && (
        <div className="card p-4">
          <div className="flex items-center justify-between gap-3">
            <div>
              <p className="text-sm font-semibold text-slate-900">
                {remediesData.guidance.title}
              </p>
              <p className="mt-1 text-sm text-slate-600">
                {remediesData.guidance.description}
              </p>
            </div>
            <button
              className="btn btn-secondary"
              onClick={() => {
                localStorage.setItem("myv_guidance_remedies", "true");
                setDismissed(true);
                logActivity("guidance_dismissed", { page: "remedies" });
              }}
            >
              {remediesData.guidance.ctaLabel}
            </button>
          </div>
        </div>
      )}

      {filtered.length === 0 ? (
        <InfoBanner stateKey="analysisEmpty" />
      ) : (
        <div className="grid gap-4 md:grid-cols-2">
          {filtered.map((item) => (
            <div key={item.issue} className="card card-hover p-4">
              <div className="flex items-center justify-between">
                <p className="text-sm font-semibold text-slate-900">
                  {item.issue}
                </p>
                <span className="rounded-full bg-slate-100 px-3 py-1 text-xs text-slate-600">
                  {item.severity}
                </span>
              </div>
              <p className="mt-2 text-sm text-slate-600">{item.remedy}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
